import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { tabSelected } from "Pages/Admin/GlobalExecution/@signals"
import { GLOBAL_EXECUTION_TABS } from "Pages/Admin/GlobalExecution/@constants"

export default function useReportBackendApiPath() {

	const isExtrasKey = tabSelected.value === GLOBAL_EXECUTION_TABS.EXTRAS

	return {
		multipleStatus: isExtrasKey ? `${BACKEND_APIS.REPORT_EXTRA}/status-multiple` : `${BACKEND_APIS.REPORTS}/status-multiple`,
		backendUrl: isExtrasKey ? BACKEND_APIS.REPORT_EXTRA : BACKEND_APIS.REPORTS,
		backendService: isExtrasKey ? SERVICES_TYPE.REPORTS_EXTRA : SERVICES_TYPE.REPORTS,
		searchUrl: BACKEND_APIS.SEARCH,
		searchesUrl: isExtrasKey ? `${BACKEND_APIS.REPORT_EXTRA}/status` : `${BACKEND_APIS.REPORTS}/status`,
		searchesBySiteUrl: isExtrasKey ? `${BACKEND_APIS.REPORT_EXTRA}/status-per-site` : `${BACKEND_APIS.REPORTS}/status-per-site`,
		reportType: isExtrasKey ? "extras" : "",
		historic: isExtrasKey ? `${BACKEND_APIS.REPORT_EXTRA}/executions` : `${BACKEND_APIS.REPORTS}/executions`,
		executionStatus: isExtrasKey ? `${BACKEND_APIS.REPORT_EXTRA}/execution-status` : `${BACKEND_APIS.REPORTS}/execution-status`,
		forceUrl: isExtrasKey ? `${BACKEND_APIS.INTERMEDIARY}/check/executions/reports-extras/force` : `${BACKEND_APIS.INTERMEDIARY}/check/executions/report/force`,
		retryUrl: `${BACKEND_APIS.INTERMEDIARY}/retry/executions`
	}
}